export const userColumns = [
  { field: "_id", headerName: "ID", width: 220 },
  {
    field: "user",
    headerName: "User",
    width: 230,
    renderCell: (params) => {
      return (
        <div className="cellWithImg">
          <img className="cellImg" src={params.row.img || "https://i.ibb.co/MBtjqXQ/no-avatar.gif"} alt="avatar" />
          {params.row.username}
        </div>
      );
    },
  },
  {
    field: "email",
    headerName: "Email",
    width: 230,
  },
];
export const courseColumns = [
  { field: "_id", headerName: "ID", width: 220 },
  {
    field: "name",
    headerName: "Name",
    width: 150,
  },
  {
    field: "text",
    headerName: "Text",
    width: 100,
  },
  {
    field: "duration",
    headerName: "Duration",
    width: 100,
  },
  {
    field: "fees",
    headerName: "Fees",
    width: 100,
  },
  {
    field: "eligibility",
    headerName: "Eligibility",
    width: 100,
  },
  {
    field: "universities",
    headerName: "Universities",
    width: 100,
  },
];

export const blogColumns = [
  { field: "title", headerName: "Title", width: 200 },
  { field: "author", headerName: "Author", width: 150 },
  { field: "content", headerName: "Content", width: 300 },
  { field: "createdAt", headerName: "Created At", width: 180 },
];




// export const dataColumns = [
//   { field: "_id", headerName: "ID", width: 250 },
//   {
//     field: "grade",
//     headerName: "Grade",
//     width: 50,
//   },
//   {
//     field: "subject",
//     headerName: "Subject",
//     width: 200,
//   },
//   {
//     field: "chapterCount",
//     headerName: "ChapterCount",
//     width: 50,
//   },
//   {
//     field: "chapterdetails",
//     headerName: "Chapterdetails",
//     width: 100,
//   },
// ];
export const studentColumns = [
  { field: "_id", headerName: "ID", width: 70 },
  {
    field: "user",
    headerName: "User",
    width: 230,
    renderCell: (params) => {
      return (
        <div className="cellWithImg">
          <img className="cellImg" src={params.row.img || "https://i.ibb.co/MBtjqXQ/no-avatar.gif"} alt="avatar" />
          {params.row.username}
        </div>
      );
    },
  },
  {
    field: "email",
    headerName: "Email",
    width: 230,
  },

  {
    field: "phone",
    headerName: "Phone",
    width: 100,
  },
  {
    field: "country",
    headerName: "Country",
    width: 100,
  },
  {
    field: "grade",
    headerName: "grade",
    width: 50,
  },
  {
    field: "isTeacher",
    headerName: "teacher",
    width: 100,
  },
  // {
  //   field: "phone",
  //   headerName: "Phone",
  //   width: 100,
  // },
];
// export const teacherColumns = [
//   { field: "_id", headerName: "ID", width: 70 },
//   {
//     field: "user",
//     headerName: "User",
//     width: 190,
//     renderCell: (params) => {
//       return (
//         <div className="cellWithImg">
//           <img className="cellImg" src={params.row.img || "https://i.ibb.co/MBtjqXQ/no-avatar.gif"} alt="avatar" />
//           {params.row.username}
//         </div>
//       );
//     },
//   },
//   {
//     field: "email",
//     headerName: "Email",
//     width: 230,
//   },

//   {
//     field: "phone",
//     headerName: "Phone",
//     width: 100,
//   },
//   {
//     field: "country",
//     headerName: "Country",
//     width: 100,
//   },
//   {
//     field: "grade",
//     headerName: "grade",
//     width: 100,
//   },
//   {
//     field: "teacherSection",
//     headerName: "Section",
//     width: 100,
//   }
//   // {
//   //   field: "phone",
//   //   headerName: "Phone",
//   //   width: 100,
//   // },
// ];
// export const counsellorColumns = [
//   { field: "_id", headerName: "ID", width: 70 },
//   {
//     field: "user",
//     headerName: "User",
//     width: 230,
//     renderCell: (params) => {
//       return (
//         <div className="cellWithImg">
//           <img className="cellImg" src={params.row.img || "https://i.ibb.co/MBtjqXQ/no-avatar.gif"} alt="avatar" />
//           {params.row.username}
//         </div>
//       );
//     },
//   },
//   {
//     field: "email",
//     headerName: "Email",
//     width: 230,
//   },

//   {
//     field: "phone",
//     headerName: "Phone",
//     width: 100,
//   },
//   {
//     field: "country",
//     headerName: "Country",
//     width: 100,
//   },
//   // {
//   //   field: "grade",
//   //   headerName: "grade",
//   //   width: 100,
//   // },
//   // {
//   //   field: "city",
//   //   headerName: "City",
//   //   width: 100,
//   // },
//   {
//     field: "phone",
//     headerName: "Phone",
//     width: 100,
//   },
// ];








export const roomColumns = [
  { field: "_id", headerName: "ID", width: 70 },
  {
    field: "title",
    headerName: "Title",
    width: 230,
  },
  {
    field: "desc",
    headerName: "Description",
    width: 200,
  },
  {
    field: "price",
    headerName: "Price",
    width: 100,
  },
  {
    field: "maxPeople",
    headerName: "Max People",
    width: 100,
  },
];
